import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import CloseIcon from '@mui/icons-material/Close';
import Zoom from '@mui/material/Zoom';

function TabPanel({ children, value, index }) {
  if (value !== index) return null;
  return <Box sx={{ py: 2 }}>{children}</Box>;
}

export default function WelcomeModal({ open, onClose }) {
  const [tab, setTab] = useState(0);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Zoom}
      TransitionProps={{ timeout: 300 }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', px: 3, pt: 2.5 }}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
            Welcome to Bellow
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Ignite sparks of inspiration
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small" aria-label="Close" sx={{ mt: -0.5, mr: -1 }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>

      <Box sx={{ px: 3 }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          sx={{ mb: 0 }}
        >
          <Tab label="How it works" />
          <Tab label="Why this matters" />
        </Tabs>
      </Box>

      <Divider />

      <DialogContent sx={{ px: 3, pt: 1, pb: 4 }}>
        {/* Tab 0 — How it works */}
        <TabPanel value={tab} index={0}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Box>
              <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.25 }}>
                Notice and capture
              </Typography>
              <Typography variant="body2" color="text.secondary">
                When inspiration strikes, pause and document it. This moment of
                awareness changes your relationship with inspiration.
              </Typography>
            </Box>

            <Box>
              <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.25 }}>
                Reflect on what happened
              </Typography>
              <Typography variant="body2" color="text.secondary">
                What was the inspiration? Your own words here become the prompt to experiment with later.
              </Typography>
            </Box>

            <Box>
              <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.25 }}>
                Recognize your patterns
              </Typography>
              <Typography variant="body2" color="text.secondary">
                After collecting sparks, patterns emerge. Your top verbs and subjects
                surface and invite you to experiment with a new spark of inspiration.
              </Typography>
            </Box>

            <Box>
              <Typography variant="body1" sx={{ fontWeight: 600, mb: 0.25 }}>
                No streaks, points, or badges
              </Typography>
              <Typography variant="body2" color="text.secondary">
                This is a tool that helps achieve mindful self-reflection
                rather than high scores.
              </Typography>
            </Box>
          </Box>
        </TabPanel>

        {/* Tab 1 — Why this matters */}
        <TabPanel value={tab} index={1}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5 }}>
            Bellow is rooted in research on awareness-based behavior change.
            Studies show that awareness itself creates change. When you recognize
            your patterns, you can shape them.
          </Typography>

          <Typography variant="body1" sx={{ fontWeight: 600, mb: 1.5 }}>
            Tracking your sparks:
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }}>
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Reveals your creative conditions
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Discover that books inspire you more than feeds, or morning
                curiosity leads to evening execution.
              </Typography>
            </Box>

            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Builds momentum
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Identify the first small task for a spark. Finishing small tasks
                reinforces inspiration and confidence.
              </Typography>
            </Box>

            <Box>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                Becomes useful when you struggle
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Understanding your patterns gives you tools to push through
                resistance.
              </Typography>
            </Box>
          </Box>

        </TabPanel>
      </DialogContent>
    </Dialog>
  );
}
